import React, { useState } from "react"
import isEmpty from "validator/lib/isEmpty"
import isMobilePhone from "validator/lib/isMobilePhone"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { addUser } from "services"
import { Button, Modal, TextField } from "components"
import classes from "./CheckoutAddUserModal.module.scss"
import clsx from "clsx"

const initialFormState = {
  fullName: "",
  mobilePhone: "",
  note: ""
}

const CheckoutAddUserModal = props => {
  const {
    resetAllStates,
    showAddUserModal,
    setShowAddUserModal,
    setSelectedUserAccount
  } = props

  const [t, i18n] = useTranslation()

  const cashierBranchId =
    useSelector(state => state.userAccountInfo.branchId)

  const [sending, setSending] = useState(false)
  const [form, setForm] = useState(initialFormState)
  const [formErrors, setFormErrors] = useState(initialFormState)

  const handleExited = () => {
    setSending(false)

    setForm({ ...initialFormState })
  }

  const handleCancel = () => {
    setShowAddUserModal(false)
  }

  const handleChange = (value, name) => {
    setForm(prev => ({
      ...prev, [name]: value
    }))
  }

  const validate = () => {
    const errors = { ...initialFormState }
    let result = true

    if (isEmpty(form.mobilePhone)) {
      errors.mobilePhone = t("شماره_موبایل_الزامی_است")
      result = false
    } else if (!isMobilePhone(`+98${form.mobilePhone.substring(1)}`, ["fa-IR"], { strictMode: true, })) {
      errors.mobilePhone = t("شماره_موبایل_معتبر_نیست")
      result = false
    }

    if (isEmpty(form.fullName)) {
      errors.fullName = t("نام_و_نام_خانوادگی_الزامی_است")
      result = false
    } else if (form.fullName.length < 6 || form.fullName.length > 50) {
      errors.fullName = t("نام_و_نام_خانوادگی_باید_بین_6_تا_50_کاراکتر_باشد")
      result = false
    }

    if (isEmpty(form.note)) {

    }

    setFormErrors({ ...errors })

    return result
  }

  const handleAdd = async () => {
    if (!validate()) return

    setSending(true)
    try {
      const response =
        await addUser({
          registeredFromBranchId: cashierBranchId,
          fullName: form.fullName.trim(),
          mobilePhone: `+98${form.mobilePhone.trim().substring(1)}`,
          note: form.note.trim()
        })

      resetAllStates()

      setSelectedUserAccount({ ...response })

      setShowAddUserModal(false)
    } catch (err) {
      console.log(err)

      setFormErrors(prev => ({
        ...prev,
        fullName:
          err?.response?.data?.message
      }))

      setSending(false)
    }
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Modal
      show={showAddUserModal}
      onExited={handleExited}
      onHide={() => setShowAddUserModal(false)}
    >
      <div className={classes["container"]}>
        <div className={classes["title"]}>
          {t("افزودن_مشتری")}
        </div>

        <TextField
          inputMode="decimal"
          label={t("شماره_تلفن_مشتری")}
          className={classes["input"]}
          value={form.mobilePhone}
          onChange={(e) => handleChange(e.target.value, "mobilePhone")}
          error={formErrors.mobilePhone}
          withoutSpace
        />


        <TextField
          label={t("نام_و_نام_خانوادگی_مشتری")}
          value={form.fullName}
          className={classes["input"]}
          onChange={(e) => handleChange(e.target.value, "fullName")}
          error={formErrors.fullName}
        />

        <TextField
          label={t("توضیحات_مشتری")}
          maxLength={300}
          value={form.note}
          onChange={(e) => handleChange(e.target.value, "note")}
          error={formErrors.note}
        />

        <div className={classes["buttons"]}>
          <Button
            onClick={handleAdd}
            color="success"
            loading={sending}
            className={clsx(
              classes["button"],
              isLtr && classes["button-ltr"]
            )}
          >
            {t("ذخیره")}
          </Button>

          <Button
            onClick={handleCancel}
            color="danger"
            disabled={sending}
          >
            {t("انصراف")}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default CheckoutAddUserModal